import PropTypes from 'prop-types'
import './SeleccionPublicar.css'

const OPCIONES = [
  {
    id: 'simple',
    esMasiva: false,
    icono: 'fa fa-file-text-o',
    titulo: 'Publicación simple',
    descripcion: 'Una única publicación'
  },
  {
    id: 'masiva',
    esMasiva: true,
    icono: 'fa fa-clone',
    titulo: 'Publicación masiva',
    descripcion: 'Varias publicaciones a la vez'
  }
]

const TipoPublicacion = ({ onClick, seleccionado }) => {
  return (
    <div
      className="seleccion-grupo seleccion-grupo--dos"
      role="radiogroup"
      aria-label="Tipo de publicación"
    >
      {OPCIONES.map((opcion) => {
        const estaSeleccionado = seleccionado === opcion.esMasiva
        return (
          <button
            key={opcion.id}
            type="button"
            name={`btnPublicacion${opcion.esMasiva ? 'Masiva' : 'Simple'}`}
            role="radio"
            aria-checked={estaSeleccionado}
            className={`seleccion-card ${estaSeleccionado ? 'seleccion-card--activa' : ''}`}
            onClick={() => onClick(opcion.esMasiva)}
          >
            {estaSeleccionado && (
              <i className="fa fa-check-circle seleccion-card-check" aria-hidden="true" />
            )}
            <span className="seleccion-card-icono">
              <i className={opcion.icono} aria-hidden="true" />
            </span>
            <span className="seleccion-card-texto">
              <span className="seleccion-card-titulo">{opcion.titulo}</span>
              <span className="seleccion-card-descripcion">{opcion.descripcion}</span>
            </span>
          </button>
        )
      })}
    </div>
  )
}

TipoPublicacion.propTypes = {
  onClick: PropTypes.func.isRequired,
  seleccionado: PropTypes.bool
}

export default TipoPublicacion
